export default __webpack_public_path__ + "static/media/NoPhone.c5131614.png";